<script lang="ts">
	import { tenantImages } from '@store/tenantImages'
</script>

<svelte:head>
	<link href={$tenantImages.favicon || '/favicon.ico'} rel="icon" />
</svelte:head>
